<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { useModal } from "#/composables/useModal";
import type { IProduct } from "#/types/iCardProduct";
import { getLocaleName } from "#/utils/i18next";

interface Emits {
	confirm: [IProduct["idSystem"]];
}

interface Props {
	hasPromoCode?: boolean;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const { t, i18next } = useTranslation();
const { visible, context, close } = useModal<IProduct>("cart-delete-confirm");

const onConfirm = () => {
	emit("confirm", context.value.idSystem);
	close();
};
</script>

<template>
	<Transition name="fade">
		<div v-if="visible" class="cart_deletion_modal_overlay" @click.self="close">
			<div class="cart_deletion_modal_content">
				<div class="cart_deletion_modal_title">{{ t(`modal.cart-delete.title`, { name: getLocaleName(context, i18next.language) }) }}</div>
				<div class="cart_deletion_modal_body">{{ t(`modal.cart-delete.body`) }}</div>
				<div class="cart_deletion_modal_body" v-if="props.hasPromoCode">{{ t(`modal.cart-delete.body-promo`) }}</div>
				<div class="cart_deletion_modal_footer">
					<button type="button" class="primary" @click="onConfirm">{{ t(`modal.cart-delete.button.confirm`) }}</button>
					<button type="button" @click="close">{{ t(`modal.cart-delete.button.cancel`) }}</button>
				</div>
			</div>
		</div>
	</Transition>
</template>

<style lang="scss" scoped>
  @use './cartDeleteConfirm.scss';
</style>
